<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar" class="sidebar-container">
            <div class="shadow-bottom"></div>

            <ul id="sidebar-menu" class="list-unstyled menu-categories">

                <!-- Menu Visão Geral com submenu para Professores -->
                <li class="menu" v-if="isProfessor">
                    <a href="javascript:;" class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#visao-geral-submenu" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-calendar">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                <line x1="16" y1="2" x2="16" y2="6" />
                                <line x1="8" y1="2" x2="8" y2="6" />
                                <line x1="3" y1="10" x2="21" y2="10" />
                            </svg>
                            <span>{{ $t('Visão geral') }}</span>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </a>
                    <ul class="collapse submenu list-unstyled" id="visao-geral-submenu">
                        <li>
                            <router-link to="/" @click="toggleMobileMenu">{{ $t('Início') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/dashboard-educador-digital" @click="toggleMobileMenu">{{ $t('Painel Educador') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/financeiro" @click="toggleMobileMenu">{{ $t('Financeiro') }}</router-link>
                        </li>
                    </ul>
                </li>

                <!-- Menu Visão Geral padrão para outros usuários (não professores) -->
                <li class="menu" v-else>
                    <router-link to="/" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-calendar">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                <line x1="16" y1="2" x2="16" y2="6" />
                                <line x1="8" y1="2" x2="8" y2="6" />
                                <line x1="3" y1="10" x2="21" y2="10" />
                            </svg>
                            <span>{{ $t('Visão geral') }}</span>
                        </div>
                    </router-link>
                </li>

                <!-- Menu principal: mesmos itens para todos os planos de professor (módulos via API) -->
                <li id="alunos-menu" class="menu">
                        <router-link to="/alunos" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-users">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                                <span>{{ $t('Alunos') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li class="menu" v-if="hasTurmasAccess">
                        <router-link to="/turmas" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M19.9998 10V7.2C19.9998 6.0799 19.9998 5.51984 19.806 5.09202C19.6355 4.71569 19.3636 4.40973 19.0291 4.21799C18.6488 4 18.151 4 17.1553 4H6.8442C5.84855 4 5.35073 4 4.97044 4.21799C4.63593 4.40973 4.36396 4.71569 4.19352 5.09202C3.99976 5.51984 3.99976 6.0799 3.99976 7.2V10M6.33887 14H6.34887M3.50977 20C3.9216 18.8348 5.03284 18 6.33906 18C7.64528 18 8.75652 18.8348 9.16835 20M11.9989 14H12.0089M9.1698 20C9.58164 18.8348 10.6929 18 11.9991 18C13.3053 18 14.4166 18.8348 14.8284 20M17.6588 14H17.6688M14.8297 20C15.2415 18.8348 16.3528 18 17.659 18C18.9652 18 20.0765 18.8348 20.4883 20M7.33887 14C7.33887 14.5523 6.89115 15 6.33887 15C5.78658 15 5.33887 14.5523 5.33887 14C5.33887 13.4477 5.78658 13 6.33887 13C6.89115 13 7.33887 13.4477 7.33887 14ZM12.9989 14C12.9989 14.5523 12.5512 15 11.9989 15C11.4466 15 10.9989 14.5523 10.9989 14C10.9989 13.4477 11.4466 13 11.9989 13C12.5512 13 12.9989 13.4477 12.9989 14ZM18.6588 14C18.6588 14.5523 18.2111 15 17.6588 15C17.1065 15 16.6588 14.5523 16.6588 14C16.6588 13.4477 17.1065 13 17.6588 13C18.2111 13 18.6588 13.4477 18.6588 14Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span>{{ $t('Turmas') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li class="menu" v-if="hasTurmasAccess">
                        <router-link to="/atividades" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-clipboard">
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                                </svg>
                                <span>{{ $t('Atividades') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li id="redacoes-menu" class="menu" v-if="hasRedacoesAccess">
                        <router-link to="/documentos" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-file-text" data-v-c3d7ea0a="">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>
                                <span>{{ $t('Redações') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li
                        v-if="hasRedacoesAccess && aceitaRevisoesTextoTerceiros"
                        id="revisoes-texto-menu"
                        class="menu"
                    >
                        <router-link to="/revisoes-texto" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-edit-3">
                                    <path d="M12 20h9"></path>
                                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                </svg>
                                <span>{{ $t('Revisões') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li class="menu" v-if="hasTemasAccess">
                        <router-link to="/temas" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book-open" data-v-c3d7ea0a="">
                                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                                </svg>
                                <span>{{ $t('Temas') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li class="menu" v-if="hasStudyPlansAccess">
                        <router-link to="/planos-estudos" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clipboard" data-v-c3d7ea0a="">
                                    <rect x="9" y="2" width="6" height="4" rx="1"></rect>
                                    <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2"></path>
                                </svg>
                                <span>{{ $t('Planos de estudos') }}</span>
                            </div>
                        </router-link>
                    </li>

                    <li class="menu" v-if="hasCursosAccess">
                        <router-link to="/cursos" class="dropdown-toggle" @click="toggleMobileMenu">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book" data-v-c3d7ea0a="">
                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                                </svg>
                                <span>{{ $t('Cursos') }}</span>
                            </div>
                        </router-link>
                    </li>

                <li class="menu" v-if="hasCursosAccess">
                    <router-link to="/landing-page" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layout" data-v-c3d7ea0a="">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="3" y1="9" x2="21" y2="9"></line>
                                <line x1="9" y1="21" x2="9" y2="9"></line>
                            </svg>
                            <span>{{ $t('Minha página') }}</span>
                        </div>
                    </router-link>
                </li>

                <!-- Menu Avançado -->
                <li class="menu" v-if="hasAvancadoAccess">
                    <a href="javascript:;" class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#outros-submenu" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
                                <circle cx="12" cy="12" r="1"></circle>
                                <circle cx="19" cy="12" r="1"></circle>
                                <circle cx="5" cy="12" r="1"></circle>
                            </svg>
                            <span>{{ $t('Avançado') }}</span>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </a>
                    <ul class="collapse submenu list-unstyled" id="outros-submenu">
                        <li v-if="hasTurmasAccess">
                            <router-link to="/corretores" @click="toggleMobileMenu">{{ $t('Meus corretores') }}</router-link>
                        </li>
                        <li v-if="hasPromptsAccess">
                            <router-link to="/prompts" @click="toggleMobileMenu">{{ $t('Prompts IA') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/marcacoes-ia-presets" @click="toggleMobileMenu">{{ $t('Marcações') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/checklists" @click="toggleMobileMenu">{{ $t('Checklists') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/recursos" @click="toggleMobileMenu">{{ $t('Recursos de estudo') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/modelos-avaliacao" @click="toggleMobileMenu">{{ $t('Mod. de avaliações') }}</router-link>
                        </li>
                        <li>
                            <router-link to="/configuracoes/creditos" @click="toggleMobileMenu">{{ $t('Sistema de créditos') }}</router-link>
                        </li>
                    </ul>
                </li>
            </ul>

            <div class="sidebar-footer">
                <div class="sidebar-help-card">
                    <p class="sidebar-help-card__title">Precisa de ajuda?</p>
                    <p class="sidebar-help-card__text">
                        Acesse nossa central ou entre em contato.
                    </p>
                    <a
                        href="/ajuda"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="sidebar-help-card__btn"
                        @click="toggleMobileMenu"
                    >
                        Central de ajuda
                    </a>
                </div>

                <div class="sidebar-legal-links">
                    <a href="/termos-de-servico" target="_blank" class="legal-link" @click="toggleMobileMenu">
                        Termos
                    </a>
                    <span class="legal-separator">•</span>
                    <a href="/politica-de-privacidade" target="_blank" class="legal-link" @click="toggleMobileMenu">
                        Privacidade
                    </a>
                    <span class="legal-separator">•</span>
                    <a href="/ajuda?tab=contato" target="_blank" class="legal-link" @click="toggleMobileMenu">
                        Contato
                    </a>
                </div>
            </div>

        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';

const store = useStore();
const route = useRoute();
const userStore = useUserStore();

function usuarioAceitaRevisoesTextoTerceiros(user) {
    if (!user) return false;
    const v = user.aceita_revisoes_texto_terceiros;
    return v === true || v === 1 || v === '1';
}

const aceitaRevisoesTextoTerceiros = computed(() => {
    return (
        usuarioAceitaRevisoesTextoTerceiros(userStore.user) ||
        usuarioAceitaRevisoesTextoTerceiros(store.state.auth?.user)
    );
});

// Verifica se o usuário tem acesso a um módulo específico
const hasModuleAccess = (moduleKey) => {
    const plan = store.state.auth?.user?.active_subscription?.plan;
    if (!plan || !plan.features) return false;
    
    const moduleValue = plan.features[moduleKey];
    return moduleValue === true || moduleValue === 'true' || moduleValue === 1 || moduleValue === '1';
};

// Computed properties para cada módulo
const hasCursosAccess = computed(() => hasModuleAccess('modulo_cursos'));
const hasRedacoesAccess = computed(() => hasModuleAccess('modulo_redacoes'));
const hasTemasAccess = computed(() => hasModuleAccess('modulo_temas'));
const hasStudyPlansAccess = computed(() => hasModuleAccess('modulo_study_plans'));
const hasPromptsAccess = computed(() => hasModuleAccess('modulo_prompts'));
const hasTurmasModuleAccess = computed(() => hasModuleAccess('modulo_turmas'));

// Verifica se o usuário tem acesso a Turmas
// O módulo de turmas é independente do módulo de redações
const hasTurmasAccess = computed(() => {
    return hasTurmasModuleAccess.value;
});

// Verifica se o usuário é professor
const isProfessor = computed(() => {
    const user = store.state.auth?.user;
    if (!user) return false;
    
    // Verificar múltiplas formas de identificar professor
    // 1. Por role
    if (user.role) {
        const roleLower = String(user.role).toLowerCase();
        if (roleLower === 'professor' || roleLower === 'teacher' || roleLower === 'admin') {
            return true;
        }
    }
    
    // 2. Por is_aluno (se is_aluno é false, 0 ou não existe, é professor)
    if (user.is_aluno !== undefined) {
        // Se is_aluno é explicitamente false ou 0, é professor
        if (user.is_aluno === false || user.is_aluno === 0) {
            return true;
        }
        // Se is_aluno é true ou 1, é aluno
        if (user.is_aluno === true || user.is_aluno === 1) {
            return false;
        }
    }
    
    // 3. Por padrão, se não tem is_aluno definido e tem subscription, assumir que é professor
    // (já que alunos geralmente têm is_aluno = true)
    if (user.active_subscription) {
        return true;
    }
    
    return false;
});

// Verifica se o menu Avançado deve ser exibido
const hasAvancadoAccess = computed(() => hasPromptsAccess.value || hasTurmasAccess.value);

const fecharTodosSubmenus = () => {
    const submenus = document.querySelectorAll('#sidebar .collapse.show');
    submenus.forEach(submenu => {
        const bsCollapse = bootstrap.Collapse.getInstance(submenu);
        if (bsCollapse) {
            bsCollapse.hide();
        }
    });
};

onMounted(() => {
    userStore.getUser().catch(() => {});

    // Em tablets/mobile, restaura o estado salvo do sidebar
    if (window.innerWidth < 992) {
        const savedState = localStorage.getItem('sidebar_state_mobile');
        if (savedState !== null) {
            const shouldBeOpen = savedState === 'true';
            // Só atualiza se o estado atual for diferente do salvo
            if (store.state.is_show_sidebar !== shouldBeOpen) {
                store.commit('toggleSideBar', shouldBeOpen);
            }
        } else {
            // Sem preferência salva: mantém menu recolhido no tablet (is_show_sidebar true no CSS mobile)
            if (!store.state.is_show_sidebar) {
                store.commit('toggleSideBar', true);
            }
        }
    }
    
    const currentPath = window.location.pathname;
    const selector = document.querySelector(`#sidebar a[href="${currentPath}"]`);

    if (selector) {
        const parentSubmenu = selector.closest('.collapse');
        if (!parentSubmenu) {
            // Se o item não está em um submenu, fecha todos os submenus
            fecharTodosSubmenus();
        } else {
            // Se está em um submenu, abre apenas o submenu pai
            const bsCollapse = new bootstrap.Collapse(parentSubmenu, {
                toggle: false
            });
            bsCollapse.show();
        }
    }
    
    // Verifica se está em uma página do submenu "Visão Geral" e abre o menu
    verificarEAbrirSubmenuVisaoGeral();
    verificarEAbrirSubmenuAvancado(route.path);
});

const verificarEAbrirSubmenuVisaoGeral = () => {
    const rotasSubmenuVisaoGeral = ['/', '/financeiro', '/dashboard-educador-digital'];
    const currentPath = window.location.pathname;
    
    if (rotasSubmenuVisaoGeral.includes(currentPath)) {
        // Pequeno delay para garantir que o DOM esteja pronto
        setTimeout(() => {
            const submenuVisaoGeral = document.querySelector('#visao-geral-submenu');
            if (submenuVisaoGeral) {
                // Verifica se o submenu já está aberto
                if (!submenuVisaoGeral.classList.contains('show')) {
                    const bsCollapse = new bootstrap.Collapse(submenuVisaoGeral, {
                        toggle: false
                    });
                    bsCollapse.show();
                }
            }
        }, 100);
    }
};

const verificarEAbrirSubmenuPlanosEstudos = () => {
    const rotasSubmenuPlanosEstudos = ['/planos-estudos', '/recursos', '/recurso'];
    const currentPath = window.location.pathname;
    
    if (rotasSubmenuPlanosEstudos.some(rota => currentPath.startsWith(rota))) {
        setTimeout(() => {
            const submenuPlanosEstudos = document.querySelector('#planos-estudos-submenu');
            if (submenuPlanosEstudos) {
                if (!submenuPlanosEstudos.classList.contains('show')) {
                    const bsCollapse = new bootstrap.Collapse(submenuPlanosEstudos, {
                        toggle: false
                    });
                    bsCollapse.show();
                }
            }
        }, 100);
    }
};

/** Abre o submenu Avançado quando a rota atual pertence a esse grupo. */
const verificarEAbrirSubmenuAvancado = (path) => {
    const p = path || window.location.pathname;
    const match =
        p.startsWith('/prompts') ||
        (p.startsWith('/prompt') && !p.startsWith('/prompts')) ||
        p.startsWith('/marcacoes-ia-presets') ||
        p.startsWith('/marcacoes-ia-preset') ||
        p.startsWith('/checklists') ||
        (p.startsWith('/checklist') && !p.startsWith('/checklists')) ||
        p.startsWith('/recursos') ||
        (p.startsWith('/recurso') && !p.startsWith('/recursos')) ||
        p.startsWith('/modelos-avaliacao') ||
        p.startsWith('/corretores') ||
        p.startsWith('/configuracoes/creditos');
    if (!match) return;
    setTimeout(() => {
        const submenu = document.querySelector('#outros-submenu');
        if (submenu && !submenu.classList.contains('show')) {
            const bsCollapse = new bootstrap.Collapse(submenu, { toggle: false });
            bsCollapse.show();
        }
    }, 100);
};

const toggleMobileMenu = (event) => {
    const clickedLink = event.currentTarget;
    const hasSubmenu = clickedLink.getAttribute('data-bs-toggle') === 'collapse';
    const isSubmenuItem = clickedLink.closest('.submenu') !== null;

    // Só fecha os submenus se não for um item de submenu e não tiver submenu próprio
    if (!hasSubmenu && !isSubmenuItem) {
        fecharTodosSubmenus();
    }

    if (window.innerWidth < 991) {
        store.commit('toggleSideBar', false);
    }
};

// Observa mudanças na rota para atualizar o estado dos menus
watch(() => route.path, (newPath) => {
    const selector = document.querySelector(`#sidebar a[href="${newPath}"]`);
    if (selector && !selector.getAttribute('data-bs-toggle') && !selector.closest('.submenu')) {
        fecharTodosSubmenus();
    }
    
    // Em tablets/mobile, garante que o sidebar permaneça fechado se foi fechado manualmente
    if (window.innerWidth < 992) {
        const savedState = localStorage.getItem('sidebar_state_mobile');
        if (savedState === 'false') {
            // Se o usuário fechou manualmente, mantém fechado
            store.commit('toggleSideBar', false);
        }
    }
    
    // Verifica se está em uma página do submenu "Visão Geral" e abre o menu
    verificarEAbrirSubmenuVisaoGeral();
    // Verifica se está em uma página do submenu "Planos de Estudos" e abre o menu
    verificarEAbrirSubmenuPlanosEstudos();
    verificarEAbrirSubmenuAvancado(newPath);
});
</script>

<style scoped>
.sidebar-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
}

#sidebar-menu {
    flex: 1 1 auto;
    min-height: 0;
}

.sidebar-footer {
    flex: 0 0 auto;
    margin-top: auto;
    padding-bottom: 4px;
}

.sidebar-legal-links {
    flex-shrink: 0;
    text-align: center;
    padding: 8px 12px 12px;
    border-top: none;
}

.legal-link {
    color: #888ea8;
    text-decoration: none;
    font-size: 11px;
    font-weight: 500;
    transition: color 0.2s ease;
}

.legal-link:hover {
    color: #3b3f5c;
    text-decoration: none;
}

.legal-separator {
    color: #c0c6d4;
    font-size: 8px;
    margin: 0 4px;
}
</style>